module.exports = __webpack_public_path__ + "img/relatorios-gerenciais.12e0eedc.webp";